import React from 'react';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../@communityshare/ui/card/IconSection';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';

export default function Educators(props) {
  const { site } = props;

  const roles = useConnect('role.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  return (
    <IconSection
      icon={AcademicCapIcon}
      tooltip="Educators"
      title={roles.state === PayloadStates.FETCHING ?
        '...' :
        roles.meta.totalCount
      }
    />
  );
}
